module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kyushu-3-2476d7f248b9b71d792b4b849beb901e.png";